import React, { memo } from "react";
import classnames from "classnames";
import { Element } from "../base";
import MessageHeader from "./header";
import MessageBody from "./body";
interface IProps {
    className?: string;
    children: React.ReactNode;
    size?: "small" | "medium" | "large";
    color?: string;
}

function Message(props: IProps) {
    const { className, children, size, color, ...rest } = props;
    return (
        <Element
            className={classnames("message", className, {
                [`is-${color}`]: color,
                [`is-${size}`]: size,
            })}
            {...rest}
        >
            {children}
        </Element>
    );
}

Message.Header = MessageHeader;
Message.Body = MessageBody;

export default memo(Message);
